import { publish, uuid } from 'ert-framebus';
import { PubSubMessages } from '../../../config';
import { DropdownOptions, WidgetHandle,
         BreadcrumbOption, UIService} from 'navigator-header';

export class UIServiceImpl implements UIService {

    addDropdown(pos: number, options: DropdownOptions): WidgetHandle {
        const id = uuid();
        publish(PubSubMessages.addDropdown, pos, options, id);
        return { id };
    }

    removeDropdown(handle: WidgetHandle): void {
        publish(PubSubMessages.removeDropdown, handle.id);
    }

    setBreadcrumbs(options: BreadcrumbOption[]): void {
        publish(PubSubMessages.setBreadcrumbs, options);
    }

    registerClientRoot(handler: Function): void {
        publish(PubSubMessages.registerClientRoot, handler);
    }
}
